import { useCallback, useMemo } from "react";
import { useQueryParams } from "./useQueryParams";
import { History } from "history";

export const useQueryParamState = <T = string>(
  history: History,
  paramName: string
) => {
  const params = useQueryParams();

  const paramValue = params[paramName];

  const parsedParamValue: T = useMemo(() => {
    if (!!paramValue && !isNaN(Number(paramValue))) {
      return Number(paramValue) as T;
    }

    return paramValue as unknown as T;
  }, [paramValue]);

  const setParamValue = useCallback(
    (value: T, replace: boolean = false) => {
      const currentParams = new URLSearchParams(history.location.search);
      if (value != null && value !== "") {
        currentParams.set(paramName, value.toString());
      } else {
        currentParams.delete(paramName);
      }
      if (replace) {
        history.replace({ search: currentParams.toString() });
      } else {
        history.push({ search: currentParams.toString() });
      }
    },
    [history, paramName]
  );

  return [parsedParamValue, setParamValue] as const;
};
